import postRobot from 'post-robot';
// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {containerTemplate} from '../container';
import {CardInputProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {transformStyle, validateComponentProps} from '../utils';
import {config} from '../config';
import {getPaymentMethods} from '../api';

export * from './types';

const CREATE_TOKEN_EVENT = 'CREATE_TOKEN';

const getCreateTokenFunction = (ref: any) => {
  if (ref.state?.__createToken) {
    return ref.state.__createToken;
  }
  if (ref.parent?.state?.__createToken) {
    return ref.parent.state.__createToken;
  }
  if (ref.state?.parent?.state?.__createToken) {
    return ref.state.parent.state.__createToken;
  }
  throw new Error('Index is not registered');
};

export const createToken = async (
  component?: MoneiComponent<CardInputProps>,
  options?: any
): Promise<{token?: string; error?: string}> => {
  const {data} = await getCreateTokenFunction(component)(options);
  return data;
};

const options: ComponentOptionsType<CardInputProps> = {
  tag: 'monei-card-input',
  url: config.cardInputUrl,
  dimensions: {
    width: '100%',
    height: 'auto'
  },
  autoResize: {
    width: false,
    height: true
  },
  props: {
    accountId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    sessionId: {
      type: zoid.PROP_TYPE.STRING,
      required: false,
      alias: 'orderId'
    },
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    onBlur: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onEnter: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onChange: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onFocus: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    placeholders: {
      type: zoid.PROP_TYPE.OBJECT,
      required: false
    },
    errorMessages: {
      type: zoid.PROP_TYPE.OBJECT,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    },
    __getConfig: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props}: any) => {
        return getPaymentMethods.bind(null, props);
      }
    }
  },
  validate: validateComponentProps,
  containerTemplate: (params) => {
    params.state.__createToken = (data: any = {}) => {
      if (!params.frame) {
        throw new Error('CardInput instance is not registered');
      }
      return postRobot.send(params.frame.contentWindow, CREATE_TOKEN_EVENT, data, {
        domain: config.domain
      });
    };
    return containerTemplate(params);
  },
  prerenderTemplate: ({doc, props}) => {
    const html = doc.createElement('html');
    const body = doc.createElement('body');
    body.style.margin = '0';
    const div = doc.createElement('div');
    div.style.height = '36px';
    div.style.boxSizing = 'border-box';
    const style = props.style || props.innerStyle;
    if (style?.base) {
      Object.assign(div.style, transformStyle(style.base));
    }
    if (style?.loading) {
      Object.assign(div.style, transformStyle(style.loading));
    }
    body.appendChild(div);
    html.appendChild(body);
    return html;
  }
};

export const CardInput: MoneiComponent<CardInputProps> = zoid.create(options);
